// import React, { useState } from "react";
// import BreadCrumb from "../../../Components/Common/BreadCrumb";
// import ImportDataService from "../../../services/OrderingServices/ImportDataService";
// import toast from "react-hot-toast";
// import {
//   Card,
//   CardBody,
//   Modal,
//   ModalHeader,
//   ModalBody,
//   ModalFooter,
// } from "reactstrap";

// const DragDropImport = () => {
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [isDragging, setIsDragging] = useState(false);
//   const [uploading, setUploading] = useState(false);
//   const [modalOpen, setModalOpen] = useState(false);
//   const [responseData, setResponseData] = useState(null);

//   // handle file drop
//   const handleDrop = (event) => {
//     event.preventDefault();
//     event.stopPropagation();
//     setIsDragging(false);

//     if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
//       const file = event.dataTransfer.files[0];
//       setSelectedFile(file);
//       event.dataTransfer.clearData();
//     }
//   };

//   // handle drag events
//   const handleDragOver = (event) => {
//     event.preventDefault();
//     event.stopPropagation();
//     setIsDragging(true);
//   };

//   const handleDragLeave = (event) => {
//     event.preventDefault();
//     event.stopPropagation();
//     setIsDragging(false);
//   };

//   const handleFileChange = (event) => {
//     const file = event.target.files[0];
//     setSelectedFile(file);
//   };

//   const handleUpload = async () => {
//     if (!selectedFile) {
//       toast.error("Please select or drop a file first!");
//       return;
//     }

//     try {
//       setUploading(true);
//       const response = await ImportDataService.uploadFile(selectedFile);
//       setResponseData(response);
//       toast.success("File uploaded successfully!");
//       setModalOpen(true);
//       setSelectedFile(null);
//     } catch (error) {
//       console.error(error);
//       toast.error("Failed to upload file!");
//     } finally {
//       setUploading(false);
//     }
//   };

//   return (
//     <div className="page-content">
//       <div className="container-fluid">
//         <BreadCrumb pageTitle="Import Product Data" />
//       </div>

//       <div className="d-flex justify-content-center align-content-center align-items-center mt-0 mt-lg-5">
//         <Card className="col-12 col-lg-6 col-md-6">
//           <CardBody>
//             <h4 className="mb-3 text-center">Import Product Data</h4>
//             <p>
//               Upload a completed <strong>Product Import Template</strong> file
//               to bulk-import product data. Supported formats: <code>.xlsx</code>,{" "}
//               <code>.csv</code>.
//             </p>
//             <ul className="mb-4">
//               <li>Drag and drop your file into the box below.</li>
//               <li>Or click to select a file manually.</li>
//               <li>Then click <strong>Upload</strong> to start importing.</li>
//             </ul>

//             {/* Drag and Drop area */}
//             <div
//               onDrop={handleDrop}
//               onDragOver={handleDragOver}
//               onDragLeave={handleDragLeave}
//               className={`border border-2 rounded-3 p-4 text-center mb-3 ${
//                 isDragging ? "border-success bg-light" : "border-secondary"
//               }`}
//               style={{ cursor: "pointer" }}
//               onClick={() => document.getElementById("fileInput").click()}
//             >
//               <input
//                 id="fileInput"
//                 type="file"
//                 accept=".xlsx,.csv"
//                 className="d-none"
//                 onChange={handleFileChange}
//               />
//               {selectedFile ? (
//                 <p className="mb-0">
//                   <strong>{selectedFile.name}</strong> selected
//                 </p>
//               ) : (
//                 <p className="mb-0">
//                   Drag & drop a file here or <strong>click to browse</strong>
//                 </p>
//               )}
//             </div>

//             <div className="text-center">
//               <button
//                 className="btn btn-success"
//                 onClick={handleUpload}
//                 disabled={uploading}
//               >
//                 {uploading ? "Uploading..." : "Upload File"}
//               </button>
//             </div>
//           </CardBody>
//         </Card>
//       </div>

//       {/* Modal */}
//       <Modal
//         isOpen={modalOpen}
//         toggle={() => setModalOpen(false)}
//         static
//         backdrop={true}
//       >
//         <ModalHeader toggle={() => setModalOpen(false)}>
//           Import Result
//         </ModalHeader>
//         <ModalBody>
//           {responseData ? (
//             <div>
//               <p className="text-success">
//                 File imported successfully! ✅
//               </p>
//               {typeof responseData === "object" && (
//                 <pre className="bg-light p-2 rounded small">
//                   {JSON.stringify(responseData, null, 2)}
//                 </pre>
//               )}
//             </div>
//           ) : (
//             <p className="text-danger">No response received from server.</p>
//           )}
//         </ModalBody>
//         <ModalFooter>
//           <button
//             className="btn btn-secondary"
//             onClick={() => setModalOpen(false)}
//           >
//             Close
//           </button>
//         </ModalFooter>
//       </Modal>
//     </div>
//   );
// };

// export default DragDropImport;

import React, { useState } from "react";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import ImportDataService from "../../../services/OrderingServices/ImportDataService";
import toast from "react-hot-toast";
import {
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";

const DragDropImport = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [responseData, setResponseData] = useState(null);

  // handle file drop
  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(false);

    if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
      const file = event.dataTransfer.files[0];
      setSelectedFile(file);
      event.dataTransfer.clearData();
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(false);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };

  //   const handleUpload = async () => {
  //     if (!selectedFile) {
  //       toast.error("Please select or drop a file first!");
  //       return;
  //     }

  //     try {
  //       setUploading(true);
  //       const response = await ImportDataService.uploadFile(selectedFile);
  //       setResponseData(response);
  //       toast.success("File uploaded successfully!");
  //       setModalOpen(true);
  //       setSelectedFile(null);
  //     } catch (error) {
  //       console.error(error);
  //       toast.error("Failed to upload file!");
  //     } finally {
  //       setUploading(false);
  //     }
  //   };

  const handleUpload = async () => {
    if (!selectedFile) {
      toast.error("Please select or drop a file first!");
      return;
    }

    try {
      setUploading(true);
      const response = await ImportDataService.uploadFile(selectedFile);
      setResponseData(response);

      // Show only the message in the toast
      if (response?.message) {
        toast.success(response.message);
      } else {
        toast.success("File uploaded successfully!");
      }

      setModalOpen(true);
      setSelectedFile(null);
    } catch (error) {
      console.error(error);
      toast.error("Failed to upload file!");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb title="Import Product Data" pageTitle="Settings" />
      </div>

      <div className="d-flex justify-content-center align-items-center mt-0 mt-lg-5">
        <Card className="col-12 col-lg-6 shadow-sm border-0">
          <CardBody className="p-4">
            <h4 className="mb-3 text-center fw-semibold text-success">
              Import Product Data
            </h4>
            <p className="text-muted text-center mb-4">
              Upload a completed <strong>Product Import Template</strong> file
              to bulk import product data.
              <br />
              Supported formats: <code>.xlsx</code>
            </p>

            {/* Drag & Drop area */}
            <div
              onDrop={handleDrop}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onClick={() => document.getElementById("fileInput").click()}
              className={`border border-2 rounded-3 p-5 text-center transition-all ${
                isDragging
                  ? "border-success bg-light shadow-sm"
                  : "border-secondary-subtle"
              }`}
              style={{ cursor: "pointer" }}
            >
              <input
                id="fileInput"
                type="file"
                accept=".xlsx,.csv"
                className="d-none"
                onChange={handleFileChange}
              />

              <div className="mb-2">
                <i
                  className={`bi ${
                    selectedFile ? "bi-file-earmark-check" : "bi-cloud-arrow-up"
                  } fs-1 text-success`}
                ></i>
              </div>

              {selectedFile ? (
                <p className="fw-semibold mb-0 text-success">
                  {selectedFile.name}
                </p>
              ) : (
                <p className="mb-0 text-muted">
                  Drag & drop your file here or{" "}
                  <strong className="text-success">click to browse</strong>
                </p>
              )}
            </div>

            <div className="text-center mt-4">
              <button
                className="btn btn-success px-4"
                onClick={handleUpload}
                disabled={uploading}
              >
                {uploading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Uploading...
                  </>
                ) : (
                  "Upload File"
                )}
              </button>
            </div>
          </CardBody>
        </Card>
      </div>

      {/* Modal for response */}
      {/* <Modal
        isOpen={modalOpen}
        toggle={() => setModalOpen(false)}
        centered
        backdrop="static"
      >
        <ModalHeader toggle={() => setModalOpen(false)}>
          Import Result
        </ModalHeader>
        <ModalBody>
          {responseData ? (
            <div>
              <p className="text-success fw-semibold">
                ✅ File imported successfully!
              </p>
              {typeof responseData === "object" && (
                <pre className="bg-light p-3 rounded small border">
                  {JSON.stringify(responseData, null, 2)}
                </pre>
              )}
            </div>
          ) : (
            <p className="text-danger">No response received from server.</p>
          )}
        </ModalBody>
        <ModalFooter>
          <button
            className="btn btn-secondary"
            onClick={() => setModalOpen(false)}
          >
            Close
          </button>
        </ModalFooter>
      </Modal> */}
    </div>
  );
};

export default DragDropImport;
